import React from 'react';

import { SelectInput } from 'hosman-material';

export const allKinds = [
  { id: 1, value: 'partner', name: 'Conjoint' },
  { id: 2, value: 'ex_partner', name: 'Ex-conjoint' },
  { id: 3, value: 'tenant', name: 'Locataire' },
  { id: 4, value: 'interest_holder_sci', name: 'Indivisaire ou associé SCI' },
  { id: 5, value: 'other', name: 'Autre' },
]

const KindSelectInput = ({ kind, setKind, errors }) => {
  const handleSelect = (option) => {
    setKind({ target: { name: 'kind', value: option.value }})
  }

  return (
    <SelectInput
      name='kind'
      label='Lien à vous ou au bien'
      options={allKinds}
      selectedOption={allKinds.find(option => option.value === kind)}
      handleChange={(option) => handleSelect(option)}
      autoScroll={false}
      listHeight='h-40'
      errors={errors}
    />
  );
}

export default KindSelectInput;
